export const GET_REPORT = 'GET_REPORT';
export const GO_TO_INPUT = 'GO_TO_INPUT';
export const RESET_STATE = 'RESET_STATE';
export const IS_INPUT_SCREEN = 'IS_INPUT_SCREEN';
